/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { User } from './User';

export type EmailLog = {
    to: User;
    email_date: string;
    status: EmailLog.status;
};

export namespace EmailLog {

    export enum status {
        SENT = 'sent',
        BOUNCED = 'bounced',
    }


}

